import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { createPlatformSlice } from './actions';
import { PlatformStore } from './types';
import { ZustandStores } from '../utils';
import { createIndexedDBStorage } from '../utils/indexedDBAdapter';

export const usePlatformStore = create<PlatformStore>()(
  persist(
    (set, get, store) => ({
      ...createPlatformSlice(set, get, store),
    }),
    {
      name: ZustandStores.PLATFORM_STATE,
      storage: createJSONStorage(() => createIndexedDBStorage()),
    },
  ),
);
